function getFieldByPath(children, fieldPath, parentKey = '') {
    if (!children) {
        return null;
    }

    let result = null;

    for(const node of children) {
        const nodeKey = parentKey !== '' ? parentKey + '.' + node.key : node.key;

        if (node.children) {
            const found = getFieldByPath(node.children, fieldPath, nodeKey)
            if (found) {
                result = found;
                break;
            }
        } else if (nodeKey === fieldPath) {
            result = node;
            break;
        }
    }

    return result;
}

function getConfigFields(children, { parentKey = '', transformFn, filterFn = undefined } = {}) {
    const secrets = [];
    
    if (!children) {
        return secrets;
    }

    children.map(node => {
        const nodeKey = parentKey !== '' ? parentKey + '.' + node.key : node.key;
        if (node.children) {
            secrets.push(...getConfigFields(node.children, { parentKey: nodeKey, transformFn, filterFn }));
        } else if (filterFn ? filterFn(node, nodeKey) : (typeof node.key !== 'undefined' && node.bindingType)) {
            secrets.push(transformFn ? transformFn(node, nodeKey) : { ...node, key: nodeKey });
        }
    })

    return secrets;
}

function traverseConfigFields(children, callback, { nodeKey = '' } = {}) {
    if (!children) {
        return;
    }

    children.map(node => {
        const key = nodeKey !== '' ? nodeKey + '.' + node.key : node.key;
        if (node.children) {
            traverseConfigFields(node.children, callback, { nodeKey: key })
        } else {
            callback(node, key)
        }
    })
}

function getNestedDataFields(arr, depth) {
    depth -= 1

    if (!arr || depth < 0) {
        return []
    }

    return arr
        .filter(item => item.key)
        .map(elem => {
            return {
                key: elem.key,
                label: elem.key,
                fieldType: elem.type,
                childNodes: getNestedDataFields(elem.children, depth)
            }
        })
}

module.exports = {
    getConfigFields,
    getFieldByPath,
    traverseConfigFields,
    getNestedDataFields
}
